
export function capitalizeSpanish(text) {
	if (!text) return text

	const lowerCaseWords = new Set([
		"de",
		"del",
		"la",
		"las",
		"el",
		"los",
		"y",
		"e",
		"o",
		"u",
		"a",
		"en",
		"por",
		"para",
		"con",
		"sin",
		"sobre",
		"entre",
		"hasta",
		"desde",
		"al"
	])
	const UpperCaseWords = new Set(["rh"])

	return text
		.toLowerCase()
		.split(" ")
		.map((word, index) => {
			if (index !== 0 && lowerCaseWords.has(word)) {
				return word
			}
			if ( UpperCaseWords.has(word)) {
				return word.toUpperCase()
			}
			return word.charAt(0).toUpperCase() + word.slice(1)
		})
		.join(" ")
}
